const BASE_URL = 'https://dynaparse.com/api/v1';
const INTERNAL_KEY = process.env.REACT_APP_INTERNAL_KEY || '';

async function request(path, options = {}) {
  const res = await fetch(`${BASE_URL}${path}`, options);
  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.detail || data.message || `Request failed: ${res.status}`);
  }
  return data;
}

function authHeaders(token) {
  return { Authorization: `Bearer ${token}` };
}

function internalHeaders(token) {
  return { Authorization: `Bearer ${token}`, 'X-Internal-Key': INTERNAL_KEY };
}

// ─── Auth ──────────────────────────────────────────────────────────────────

export async function register(email, password, recaptchaToken = null) {
  return request('/auth/register', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password, recaptcha_token: recaptchaToken }),
  });
}

export async function login(email, password, recaptchaToken = null) {
  return request('/auth/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password, recaptcha_token: recaptchaToken }),
  });
}

export async function resendVerification(email) {
  return request('/auth/resend-verification', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
}

// ─── API Keys ──────────────────────────────────────────────────────────────

export async function createApiKey(token) {
  return request('/auth/api-keys', {
    method: 'POST',
    headers: authHeaders(token),
  });
}

export async function listApiKeys(token) {
  return request('/auth/api-keys', {
    headers: authHeaders(token),
  });
}

export async function deleteApiKey(token, keyId) {
  return request(`/auth/api-keys/${keyId}`, {
    method: 'DELETE',
    headers: authHeaders(token),
  });
}

// ─── Credits ───────────────────────────────────────────────────────────────

export async function getCredits(token) {
  return request('/credits', {
    headers: authHeaders(token),
  });
}

export async function createTopupInvoice(token, pack) {
  return request(`/credits/topup?pack=${encodeURIComponent(pack)}`, {
    method: 'POST',
    headers: internalHeaders(token),
  });
}

export async function getPaymentMethods(token) {
  return request('/credits/payment-methods', {
    headers: internalHeaders(token),
  });
}

export async function getOcrModels() {
  return request('/ocr/models');
}

// ─── Local storage helpers ─────────────────────────────────────────────────

export function saveToken(token) {
  localStorage.setItem('dp_token', token);
}

export function loadToken() {
  return localStorage.getItem('dp_token');
}

export function clearToken() {
  localStorage.removeItem('dp_token');
}
